import axios from 'axios';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import parseErrorResponse from './errorHandling'; // Make sure the path is correct

const useLinkSubmit = () => {
  const { t } = useTranslation();
  const [processing, setProcessing] = useState(false);

  const submitLink = useCallback(async ({ linkToken, cardToken, sessionToken, plaidPublicToken, signature }) => {
    try {
      setProcessing(true);
      const response = await axios.post('/pay-by-link-service/api/v1/submit', {
        linkToken,
        sessionToken,
        paymentCardToken: cardToken,
        plaidPublicToken,
        signature,
      });
      setProcessing(false);
      return response.data;
    } catch (err) {
      setProcessing(false);
      const error = parseErrorResponse(err);
      error.message = t(`error.${error.code}`) || t('error.unexpected');
      throw error;
    }
  }, []);

  return { submitLink, processing };
};

export default useLinkSubmit;
